export { default as MouseWheelSolidIcon } from './MouseWheelSolidIcon';
